import { render, staticRenderFns } from "./middle-warning.vue?vue&type=template&id=698cf64b&scoped=true&"
import script from "./middle-warning.vue?vue&type=script&lang=ts&"
export * from "./middle-warning.vue?vue&type=script&lang=ts&"
import style0 from "./middle-warning.vue?vue&type=style&index=0&id=698cf64b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698cf64b",
  null
  
)

export default component.exports